import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin';
import { CMSService } from '../../../services/cms-service';
import { BC } from 'model/modal-cms/bc';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Users } from 'model/modal-cms/users';

declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-validitation-bc',
  templateUrl: './validitation-bc.component.html',
  styleUrls: ['./validitation-bc.component.scss']
})
export class ValiditationBcComponent implements OnInit {

	id_agent_actuel:any;
    data_bc: any ;
    data_bc_valider:any;
    _bc: BC = new BC(null);
    mode_agent : number = 1;
      text_title_confirm_bc : any; 
       text_confirm_bc: any; 
       data_bc_urgence : any;
       direction_actuel:any;
       code: string = "ABCDEFghojklm123456789";
        _users: Users = new Users(null);

  constructor(public adminService: AdminService, public _CMSService : CMSService, private router: Router) { 
        this.id_agent_actuel = this.adminService.getUserIMIscrit();

  }

  ngOnInit() {
    this.getInfoUser();
  	
  }

  getInfoUser(){
    this._CMSService.getUsebyIM( this.id_agent_actuel)
      .subscribe(data => { 
      this.direction_actuel = data.dir_user ;
      console.log(" this.direction_actuel " +  this.direction_actuel)
      this.listAllBc();
      this.listAllBcValiderUrgence();
       this.listAllBcValider();   
     },
        err => {
          console.log(err);
        })
  }

  


  listAllBc() {
    this._CMSService.getBCAgentByDirByEtat(this.direction_actuel, "A")
      .subscribe(data => { 
       console.log(data);           
       this.data_bc = data
      },
        err => {
          console.log(err);
        })
  }

   listAllBcValider() {
    this._CMSService.getBCAgentByDirByEtat(this.direction_actuel, "V")
      .subscribe(data => { 
       console.log(data);           
       this.data_bc_valider = data
      },
        err => {
          console.log(err);
        })
  }

    listAllBcValiderUrgence() {
    this._CMSService.getBCAgentByDirByEtat(this.direction_actuel, "U")
      .subscribe(data => { 
       console.log(data);           
       this.data_bc_urgence = data
      },
        err => {
          console.log(err);
        })
  }

  

  

  getInfoBC(id_bc:any){
    this.router.navigate(['valid-bc/'+id_bc]);
    }
  

   getInfoBC_(id_bc:any){

    this._CMSService.getInfoBc(id_bc)
      .subscribe(data => { 
       console.log(data);           
       this._bc = data;
       
      this.text_title_confirm_bc = "Validation BC : " + this._bc.im + " : " + this._bc.info_patient; 
       this.text_confirm_bc = "Motif : " + this._bc.motif  + ", \n Nombre : " +  this._bc.nombre;
       this.confirm_bc();
      },
        err => {
          console.log(err);
        })
    }


    //confirmation
    confirm_bc(){
      Swal.fire({
        title: this.text_title_confirm_bc,
        icon: 'info',
        text: this.text_confirm_bc,
        showCancelButton: true,
        confirmButtonText: 'Oui, Valider.',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
        //ok btn         
        this._bc.etat_bc = "V";
        this._CMSService.updateBc(this._bc).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         } 
          this.listAllBc();           
           this._bc = new BC(null)
           success_message.show();     
         },err=>{   
         })
         
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      })
    }
     
  


SaveBC(){   
    if (this._bc.id_bc == null) {
       this._bc.im =  this.id_agent_actuel
    this._CMSService.saveBc(this._bc).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         }   
           this.listAllBc();           
           this._bc = new BC(null)
           success_message.show();          
         },err=>{   
         })
    }else{      
      this._CMSService.updateBc(this._bc).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         } 
          this.listAllBc();           
           this._bc = new BC(null)
           success_message.show();     
         },err=>{   
         })
    }
    
  }

  VoirBC(id_bc:number){
    this.router.navigate(['detail-bc/'+id_bc]);
  }


   
  

}
